import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { fetchApi } from "../../utlis/axios";
import { useSelector } from "react-redux";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";

ChartJS.register(ArcElement, Tooltip, Legend);

const MemberEducationChart = () => {
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [status, setStatus] = useState({
    high_school: 0,
    college: 0,
    university: 0,
  });
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const getFamilyStatus = async () => {
    try {
      setLoading(true);
      const result = await fetchApi.get("members-graph/", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });

      if (result.status === 200) {
        const apiData = result.data;

        // Calculate the count for each education level
        const statusCounts = apiData.reduce((counts, item) => {
          counts[item.education_or_qualification] =
            (counts[item.education_or_qualification] || 0) + 1;
          return counts;
        }, {});

        setStatus({
          high_school: statusCounts.high_school || 0,
          college: statusCounts.college || 0,
          university: statusCounts.university || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching member education data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFamilyStatus();
  }, []);

  async function handleRefresh(params) {
    setRefreshing(true);
    await getFamilyStatus();
    setRefreshing(false);
  }

  const data = {
    labels: ["High School", "College", "University"],
    datasets: [
      {
        data: [status.high_school, status.college, status.university],
        backgroundColor: ["#7086fd", "#ffae4c", "#6fd195"],
        borderColor: "#1E1E1E",
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 6,
          usePointStyle: true,
          padding: 15,
          color: "#000",
          font: { size: 14, family: "roboto", weight: "500" },
        },
      },
    },
  };

  return (
    <div className="w-full bg-white sm:p-5 p-2.5 rounded-xl shadow">
      <div className="dashboardCard">
        <div className="flex items-center gap-2 justify-between">
          <p style={{ color: "black", fontSize: "20px" }}>Members Education</p>
          <span
            onClick={handleRefresh}
            disabled={refreshing}
            className={`p-2 w-max rounded-lg cursor-pointer !border-[2px] !border-[#D8D8D8] hover:bg-gray-50 transition bg-transparent shadow-none `}
          >
            <FiRefreshCcw
              className={`text-gray-600 text-lg ${
                refreshing ? "animate-spin" : ""
              }`}
            />
          </span>
        </div>
        <Link to="/memberdetailpage">
          <div className="pie-chart dashboard-responsive min-h-[320px] flex items-center justify-center relative">
            <>
              {status.high_school === 0 &&
              status.college === 0 &&
              status.university === 0 ? (
                <p className="text-gray-500 text-center">No data available</p>
              ) : (
                <Pie data={data} options={options} height={230} />
              )}
            </>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default MemberEducationChart;
